import type React from 'react';
import { UkCouncilPoster } from './UkCouncilPoster';
import { VeniceVaporettoPoster } from './VeniceVaporettoPoster';
import type { PosterProps } from './posterTypes';

/**
 * Pluggable poster-template registry (M1.5). The dialog dropdown is driven by this
 * list; add a template here and it appears automatically. Order = dropdown order,
 * first entry = default.
 */
export type PosterTemplateId = 'uk' | 'venice';

export interface PosterTemplateDef {
  id: PosterTemplateId;
  label: string;
  Component: React.ComponentType<PosterProps>;
}

export const POSTER_TEMPLATES: PosterTemplateDef[] = [
  { id: 'uk', label: 'UK council', Component: UkCouncilPoster },
  { id: 'venice', label: 'Venice Vaporetto', Component: VeniceVaporettoPoster },
];

export const DEFAULT_POSTER_TEMPLATE_ID: PosterTemplateId = POSTER_TEMPLATES[0].id;

export function getPosterTemplate(id: PosterTemplateId): PosterTemplateDef {
  return POSTER_TEMPLATES.find((t) => t.id === id) ?? POSTER_TEMPLATES[0];
}
